/* any functionality that's shared between component variants but not needed by external components goes in this file */
import React from 'react';
import { ButtonContent, ButtonContentWrapper, LeadingIconWrapper, LoadingIconWrapper, LoadingText, TrailingIconWrapper, VisuallyHidden } from './styles';
export var ButtonLabel = function ButtonLabel(_ref) {
  var children = _ref.children,
      isLoading = _ref.isLoading,
      size = _ref.size,
      loadingText = _ref.loadingText,
      customTheme = _ref.customTheme,
      leadingIcon = _ref.leadingIcon,
      trailingIcon = _ref.trailingIcon,
      _ref$useCustomIconSiz = _ref.useCustomIconSize,
      useCustomIconSize = _ref$useCustomIconSiz === void 0 ? false : _ref$useCustomIconSiz,
      _ref$alignTrailingIco = _ref.alignTrailingIconToRight,
      alignTrailingIconToRight = _ref$alignTrailingIco === void 0 ? false : _ref$alignTrailingIco;
  // we enforce specific icon sizes according to the overall button size
  var cloneProps = {
    size: size === 'xsmall' || size === 'small' ? 'xsmall' : 'small'
  };
  return /*#__PURE__*/React.createElement(ButtonContentWrapper, null, /*#__PURE__*/React.createElement(ButtonContent, {
    isVisible: !isLoading,
    size: size,
    "aria-hidden": isLoading,
    customTheme: customTheme
  }, leadingIcon && /*#__PURE__*/React.createElement(LeadingIconWrapper, {
    hasChildren: !!children
  }, /*#__PURE__*/React.cloneElement(leadingIcon, useCustomIconSize ? {} : cloneProps)), children, trailingIcon && /*#__PURE__*/React.createElement(TrailingIconWrapper, {
    alignTrailingIconToRight: alignTrailingIconToRight
  }, /*#__PURE__*/React.cloneElement(trailingIcon, useCustomIconSize ? {} : cloneProps))), /*#__PURE__*/React.createElement(ButtonContent, {
    isVisible: isLoading,
    size: size,
    "aria-hidden": !isLoading,
    customTheme: customTheme
  }, loadingText ? /*#__PURE__*/React.createElement(LoadingText, null, loadingText) : /*#__PURE__*/React.createElement(VisuallyHidden, null, children), /*#__PURE__*/React.createElement(LoadingIconWrapper, {
    size: customTheme[size].loaderSize,
    svgColor: 'currentColor'
  })), /*#__PURE__*/React.createElement("span", {
    "aria-live": "polite",
    "data-test": "button-loading-status",
    hidden: true,
    role: "status"
  }, isLoading ? null : /*#__PURE__*/React.createElement(React.Fragment, null, children, " done loading")));
};